export const getActivityDocumentId = (value: unknown) => {
  let hash = 2166136261;
  for (const char of String(value)) {
    hash ^= char.charCodeAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return `event_${(hash >>> 0).toString(36)}`;
};
